import React from 'react';
import { trackStoreClick } from '../../analytics/pageAnalytics';
import Header from './Header';
import Events from './Events';

const Hero = ({ children }) => {
    return (
        <>
            <style>
                {`
                    @keyframes slideInFromLeft {
                        0% {
                            opacity: 0;
                            transform: translateX(-200vw) scale(0.8);
                        }
                        100% {
                            opacity: 1;
                            transform: translateX(0) scale(1);
                        }
                    }
                    
                    @keyframes textLightToOriginal {
                        0% {
                            color: #ffffff;
                            opacity: 0.3;
                        }
                        50% {
                            color: #f0f0f0;
                            opacity: 0.8;
                        }
                        100% {
                            color: #ffffff;
                            opacity: 1;
                        }
                    }
                    
                    @keyframes insideToOutside {
                        0% {
                            opacity: 0;
                            transform: scale(0.5);
                        }
                        100% {
                            opacity: 1;
                            transform: scale(1);
                        }
                    }
                @keyframes colorWave {
  0% {
    background-position: 200% center;
  }
  100% {
    background-position: -200% center;
  }
}

.drive-connect-animated {
  /* ⭐ keep your original font, size, weight — DO NOT CHANGE */
  font-weight: 500;
  color: #FFFFFF;

  /* ⭐ gradient starting lighter and ending with F44C1D */
  background: linear-gradient(
    90deg,
 
    rgba(244, 76, 29, 1) 0%,
    rgba(171, 96, 185, 1) 20%,
    rgba(72, 136, 250, 1) 30%,
    rgba(254, 64, 129, 1) 50%,
    rgba(254, 64, 83) 80%,
    rgba(254, 64, 64) 100%

  );

  background-size: 400% 100%;
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  /* ⭐ infinite animation from left to right - seamless loop */
  animation: colorWave 20s linear infinite;
}


                    
                    .hero-boottom-banneer {
                        position: absolute;
                        left: 50%;
                        bottom: -80px;
                        
                        transform: translateX(-50%);
                        width: min(95vw, 1925px);
                        height: auto;
                        z-index: 15;
                        pointer-events: none;
                    }

                    @media (min-width: 1024px) {
                        .hero-boottom-banneer {
                            bottom: -40px;
                            width: min(90vw, 1925px);
                        }
                    }

                    @media (min-width: 1536px) {
                        .hero-boottom-banneer {
                            width: min(80vw, 1380px);
                            left: 63%;
                        }
                    }

                    /* Media query for when screen height is between 10% and 80% (when viewport height is 10vw to 80vw) */
                    /* Mobile phone sizes - fully responsive */
                    @media (max-width: 374px) {
                        .hero-heading {
                            font-size: clamp(1.25rem, 6vw, 1.5rem) !important;
                        }
                            .img-2 {
                                right: auto !important;
                                left: 150px !important;
                            }
                         
                            
                        .hero-description {
                            font-size: clamp(0.75rem, 3.5vw, 0.875rem) !important;
                            max-width: 100% !important;
                            line-height: 1.4 !important;
                        }
                        
                        .hero-badge {
                            width: 100% !important;
                            max-width: 280px !important;
                            padding: 0.5rem !important;
                            height: auto !important;
                        }
                        
                        .hero-badge span {
                            font-size: clamp(0.75rem, 3.5vw, 0.875rem) !important;
                        }
                        
                        .hero-buttons {
                            justify-content: center !important;
                            width: 100% !important;
                        }
                        
                        .hero-buttons a {
                            flex: 1 !important;
                            min-width: 120px !important;
                            max-width: 150px !important;
                        }
                            .hero-boottom-banneer {
                                bottom: -8px;
                                height: 60px;
                            }
                    }
                    
                     @media (min-width: 375px) and (max-width:476px) {
                        .hero-heading {
                            font-size: clamp(1.5rem, 7vw, 2rem) !important;
                        }
                        
                        .img-2 {
                            right: auto !important;
                            left: 120px !important;
                        }
                              .hero-boottom-banneer {
                            bottom: -8px;
                            height: 60px;
                        }
                        
                        .hero-description {
                            font-size: clamp(0.875rem, 4vw, 1rem) !important;
                            line-height: 1.5 !important;
                        }
                        
                        .hero-badge {
                            width: 100% !important;
                            max-width: 240px !important;
                            padding: 0.5rem !important;
                            height: auto !important;
                        }
                        
                        .hero-buttons {
                            justify-content: center !important;
                        }
                            
                    }
                    
                    /* Media query for 375px to 425px - shift buttons left and fix responsiveness */
                    @media (min-width: 375px) and (max-width: 470px) {
                        .hero-buttons {
                            margin-left: -1px !important;
                            justify-content: flex-start !important;
                            width: 100% !important;
                            max-width: 100% !important;
                        }
                        
                        .hero-buttons a {
                            flex: 0 0 auto !important;
                            min-width: 130px !important;
                            max-width: 140px !important;
                            width: 130px !important;
                        }
                    }
                    
                    @media (min-width: 477px) and (max-width: 639px) {
                        .hero-heading {
                            font-size: clamp(1.5rem, 7vw, 2rem) !important;
                        }
                        
                        .img-2 {
                            width: 200px !important;
                            right: auto !important;
                            left: 180px !important;
                        }
                            .img-1 img {
                                width: 200px !important;
                            }
                               .hero-boottom-banneer {
                             bottom: -2px;
                             height: 180px;
                             width: 220%;
                             left:40%;
                         }
                        
                        .hero-description {
                            font-size: clamp(0.875rem, 4vw, 1rem) !important;
                            line-height: 1.5 !important;
                        }
                        
                        .hero-buttons {
                            justify-content: center !important;
                            
                        }
                            .hero-boottom-banneer {
                                height: 60px;
                                margin-left: 10px;
                            }
                            
                    }
                    
                    /* Media query for 484px to 640px - shift buttons left */
                    @media (min-width: 484px) and (max-width: 640px) {
                        .hero-buttons {
                            margin-left: -80px !important;
                        }
                    }
                    
                    /* Tablet responsive */
                    @media (min-width: 640px) and (max-width: 769px) {
                        .hero-heading {
                            font-size: clamp(2rem, 5vw, 3rem) !important;
                        }
                        
                        .hero-description {
                            font-size: clamp(1rem, 2.5vw, 1.25rem) !important;
                            line-height: 1.6 !important;
                        }
                            .car-image-2 {
                                right: 80px !important;
                            }
                                  .hero-boottom-banneer {
                            bottom:-2px;
                        }
                    }

                    
                    /* Media query for screen 2 positioning */
                    @media (min-width: 770px) and (max-width: 900px) {
                        .car-image-2 {
                            right: 110px !important;
                            left: auto !important;
                        }
                        
                        .container {
                            min-height: 110vh !important;
                        }
                         .hero-boottom-banneer {
                                height:110px;
                                bottom: -1px;
                                margin-left: 40px;
                                width: 200%;
                            }
                            
                    }
                           @media (min-width: 901px) and (max-width: 990px) {
                        .car-image-2 {
                            right: 110px !important;
                            left: auto !important;
                        }
                        
                        .container {
                            min-height: 110vh !important;
                        }
                            .hero-boottom-banneer {
                                height:110px;
                                bottom: -1px;
                                margin-left: 40px;
                                width: 200%;
                            }
                    }
                    
                    @media (min-width: 991px) and (max-width: 1020px) {
                        .car-image-2 {
                            right: 220px !important;
                            left: auto !important;
                        }
                        
                        .car-image-2 img {
                            width: 320px !important;
                            height: auto !important;
                        }
                        
                        .car-image-1 {
                            left: 130px !important;
                        }
                        
                        .car-image-1 img {
                            width: 330px !important;
                            height: auto !important;
                        }
                        
                        .container {
                            min-height: 120vh !important;
                        }
                             .hero-boottom-banneer {
                                height:110px;
                                bottom: -1px;
                                margin-left: 40px;
                                width: 200%;
                            }
                    }
                    
                    /* 1030px-1200px - Bigger phones and content positioning */
                    @media (min-width: 1021px) and (max-width: 1200px) {
                        .car-image-2 {
                            right: -30px !important;
                            left: auto !important;
                            margin-top: -40px !important;
                        }
                        
                        .car-image-2 img {
                            width: 270px !important;
                            height: auto !important;
                        }
                        
                        .car-image-1 {
                            left: -20px !important;
                            margin-top: -70px !important;
                        }
                        
                        .car-image-1 img {
                            width: 310px !important;
                            height: auto !important;
                            
                        }

                            section {
                               position: relative !important;
                            }
                         
                             .hero-boottom-banneer {
                                height: 220px;
                             
                                margin-left: 240px;
                                width: 60%;
                             }
                        
                        .hero-left-content {
                            margin-top: 60px !important;
                        }
                        
                        .hero-badge {
                            margin-top: 40px !important;
                            margin-left: -20px !important;
                        }
                        .hero-heading {
                            margin-left: -20px !important;
                        }
                        .hero-description {
                            font-size: 1rem !important;
                            margin-left: -20px !important;
                        }
                            .hero-buttons {
                                margin-left: -20px !important;
                            }
                    }
                        
                    
                    @media (min-width: 1200px) and (max-width: 1269px) {
                         .car-image-2 {
                            right: 10px !important;
                            left: auto !important;
                            margin-top: 10px !important;
                        }
                        
                        .car-image-2 img {
                            width: 330px !important;
                            height: auto !important;
                        }
                        
                        .car-image-1 {
                            left: -40px !important;
                        }
                        
                        .car-image-1 img {
                            width: 330px !important;
                            height: auto !important;
                            margin-top: -40px !important;
                        }
                            .hero-description {
                                font-size: 1rem !important;
                            }
                              section {
                               position: relative !important;
                            }
                            
                        .drive-connect-heading {
                            margin-left: 1px !important;
                        }
                          
                    }
                    
                    /* Small screens only - reduce bottom margin */
                    @media (max-width: 1200px) {
                        .drive-connect-heading {
                            margin-bottom: 1rem !important;
                        }
                    }
                    
                    /* 1270px - Move car images to the right */
                    @media (min-width: 1270px) and (max-width: 1280px) {
                        .car-image-2 {
                            right: -10px !important;
                            left: auto !important;
                        }
                        
                        .car-image-2 img {
                            width: 320px !important;
                            height: auto !important;
                            margin-top: -10px !important;
                        }
                        
                        .car-image-1 {
                            left: -30px !important;
                        }
                        
                        .car-image-1 img {
                            width: 350px !important;
                            height: auto !important;
                            margin-top: -20px !important;
                        }
                        
                        .drive-connect-heading {
                            margin-left: 1px !important;
                        }
                            .hero-description {
                                font-size: 1rem !important;
                            }
                                    section {
                               position: relative !important;
                            }
                               
                            
                            section::after {
                               content: '' !important;
                               position: absolute !important;
                               width:925px !important;
                               height: 100px !important;
                               right: 1px !important;
                              bottom: -70px !important;
                               background: #0F0F10 !important;
                               filter: blur(-10px) !important;
                               pointer-events: none !important;
                               z-index: 50 !important;
                            }
                    }
                    
                    @media (min-width: 1281px) and (max-width: 1399px) {
                        .car-image-2 {
                            right: -10px !important;
                            left: auto !important;
                            top: 180px !important;
                        }
                        .car-image-1 {
                            top: 70px !important;
                        }
                        .hero-left-content {
                            margin-top: -190px !important;
                        }
                        .container {
                            max-height: 670px !important;
                        }
                            .hero-description {
                               
                                font-size: 1rem !important;
                            }
                                  .hero-boottom-banneer {
                            bottom:-1px;
                            left: 80%;
                            height: 270px;
                        }
                                    section.min-h-\[10vh\] {
                               position: relative !important;
                            }
                            section.min-h-\[10vh\]::after {
                               content: '' !important;
                               position: absolute !important;
                               width:925px !important;
                               height: 150px !important;
                               right: 1px !important;
                              bottom: -2px !important;
                               background: #0F0F10 !important;
                               filter: blur(-10px) !important;
                               pointer-events: none !important;
                               z-index: 50 !important;
                            }
                    }
                    
                    @media (min-width: 1400px) and (max-width: 1499px) {
                        .car-image-2 {
                            right: 100px !important;
                            left: auto !important;
                            top: 170px !important;
                        }
                        .car-image-1 {
                            top: 70px !important;
                        }
                        .hero-left-content {
                            margin-top: -200px !important;
                        }
                        .container {
                            max-height: 640px !important;
                        }
                            .hero-description {
                                margin-left: 2px !important;
                                font-size: 1rem !important;
                            }
                       
                                  .hero-boottom-banneer {
                            bottom: -10px;
                            left: 70%;
                        
                                    section {
                               position: relative !important;
                            }
                       
                    }
                    
                    @media (min-width: 1500px) and (max-width: 1529px) {
                        .car-image-2 {
                            right:-40px !important;
                            left: auto !important;
                        }
                        
                        .car-image-2 img {
                            width: 380px !important;
                            height: auto !important;
                        }
                        
                        .car-image-1 {
                            left: -40px !important;
                        }
                        
                        .car-image-1 img {
                            width: 420px !important;
                            height: auto !important;
                        }
                              
                        .hero-description {
                            margin-left: 2px !important;
                            font-size: 1.1rem !important;
                        }
                    }
                    
                    /* 1530-1532px - Move car images to the right */
                    @media (min-width: 1530px) and (max-width: 1538px) {
                        .car-image-2 {
                            right: -10px !important;
                            left: auto !important;
                        }
                        
                        .car-image-2 img {
                            width: 400px !important;
                            height: auto !important;
                        }
                        
                        .car-image-1 {
                            left: -70px !important;
                        }
                        
                        .car-image-1 img {
                            width: 420px !important;
                            height: auto !important;
                        }
                        
                        .hero-description {
                            margin-left: 2px !important;
                            font-size: 1.1rem !important;
                        }
                    }
                    
                    @media (min-width: 1533px) and (max-width: 1539px) {
                        .car-image-2 {
                            right: -10px !important;
                            left: auto !important;
                        }
                        
                        .car-image-2 img {
                            width: 400px !important;
                            height: auto !important;
                            right: -130px !important;
                           
                        }
                        
                        .car-image-1 {
                            left: -80px !important;
                        }
                        
                        .car-image-1 img {
                            width: 430px !important;
                            height: auto !important;
                        }
                        
                        .hero-left-content {
                            padding-right: 2rem !important;
                        }
                        
                        .hero-badge {
                            margin-left: -90px !important;
                        }
                        
                        .hero-heading {
                            margin-left: -90px !important;
                            font-size: 4rem !important;
                        }
                        
                        .hero-description {
                            margin-left: -90px !important;
                            font-size: 1.2rem !important;
                        }
                        
                        .hero-buttons {
                            margin-left:-90px !important;
                        }
                    }
                    
                    /* 1540-1645px - Text positioned to the right */
                    @media (min-width: 1540px) and (max-width: 1645px) {
                        .car-image-2 {
                            right: auto !important;
                            left: 150px !important;
                        }
                        
                        .car-image-1 {
                            left: -40px !important;
                        }
                        
                        .car-image-2 img {
                            right: auto !important;
                            left: 280px !important;
                        }
                            .hero-boottom-banneer {
                            bottom: -20px;
                        }
                        
                        .hero-left-content {
                            padding-left: 4rem !important;
                        }
                        
                        .hero-badge {
                            margin-left: -120px !important;
                        }
                        
                        .hero-heading {
                            margin-left: -120px !important;
                            font-size: 4rem !important;
                        }
                        
                        .hero-description {
                            margin-left: -120px !important;
                            font-size: 1.2rem !important;
                        }
                        
                        .hero-buttons {
                            margin-left: -100px !important;
                        }
                    }
                    
                    @media (min-width: 1646px) and (max-width: 1900px) {
                        .car-image-2 {
                            right: 20px !important;
                            left: auto !important;
                            width: 30px !important;
                        }
                        
                        .car-image-1 {
                            left: -20px !important;
                        }

                        .hero-boottom-banneer {
                            bottom: -30px;
                        }

                        .hero-left-content {
                            padding-right: 2rem !important;
                        }
                        
                        .hero-badge {
                            margin-left: -120px !important;
                        }
                        
                        .hero-heading {
                            margin-left: -120px !important;
                        }
                        
                        .hero-description {
                            margin-left: -120px !important;
                        }
                        
                        .hero-buttons {
                            margin-left: -110px !important;
                        }
                    }
                `}
            </style>
            <div className="  bg-[#0F0F10]  relative w-full ">
            <Header />
            
            {/* Hero Section */}
            <section className="min-h-[10vh] flex items-center relative overflow-hidden pt-24 xs:pt-28 sm:pt-40 md:pt-40 lg:pt-28 xl:pt-36 2xl:pt-32 pb-6 sm:pb-8 lg:pb-12 xl:pb-16 z-10" style={{
                backgroundImage: `
                    url('/asset/bg1.png'),
                    linear-gradient(135deg, rgba(0, 0, 0, 0.7) 0%, rgba(26, 26, 26, 0.7) 100%),
                    radial-gradient(circle at 20% 50%, rgba(255, 112, 67, 0.1) 0%, transparent 50%),
                    radial-gradient(circle at 80% 20%, rgba(255, 112, 67, 0.05) 0%, transparent 50%)
                `,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat'
            }}>
       

                <div
                    className="absolute inset-0 opacity-[0.18] pointer-events-none"
                    aria-hidden="true"
                    style={{
                        backgroundImage: `
                            linear-gradient(90deg, rgba(255,255,255,0.12) 1px, transparent 1px),
                            linear-gradient(0deg, rgba(255,255,255,0.12) 1px, transparent 1px)
                        `,
                        backgroundSize: '56px 56px, 56px 56px',
                        backgroundPosition: 'center'
                    }}
                />

                <div className="container mx-auto px-4 xs:px-5 sm:px-4 md:px-6 lg:px-8 xl:px-6    xl:max-h-[600px] 2xl:max-h-[680px] 2xl:px-4 max-w-[1700px] relative z-10 w-full">
                    <div className="flex flex-col lg:flex-row items-center lg:gap-8 xl:gap-12 2xl:gap-0">
                        {/* Left Content */}
                        <div className="hero-left-content lg:w-1/2 w-full px-1 xs:px-2 sm:px-4 lg:px-6 xl:px-8 2xl:pr-10 mb-6 sm:mb-8 md:-mt-10 xl:-mt-36 lg:mb-0 relative z-30 md:flex md:flex-col md:items-center lg:block 2xl:-mt-24">
                            {/* Trusted Badge */}
                            <div 
                                className="hero-badge  inline-flex items-center w-fit sm:w-[300px] sm:h-[50px] md:w-[310px] lg:w-[344px] xl:w-[344px] 2xl:w-[344px] lg:p-3  md:h-[58px] lg:h-auto xl:h-[58px] 2xl:h-[58px] rounded-[16px] sm:rounded-[14px] gap-[8px] sm:gap-[10px]  sm:p-1.5 xl:p-2.5 2xl:p-2 mb-4 sm:mb-4 md:mb-10 lg:mb-6 xl:mb-8 2xl:mb-10 ml-0 sm:ml-2 md:mx-auto lg:ml-0 xl:ml-0 2xl:-ml-52 mt-6 sm:mt-12 md:mt-20 lg:mt-4 xl:-mt-6 2xl:mt-12"
                                style={{
                                    background: '#FFFFFF14',
                                    backdropFilter: 'blur(30px)',
                                    animation: 'insideToOutside 1.2s ease-out 1.5s both',
                                    animationFillMode: 'both',
                                    opacity: 0
                                }}
                            >
                                <img 
                                    src="/asset/carframe.png" 
                                    alt="Car Hangout Trusted Badge" 
                                    className="w-[50px] h-[40px] sm:w-[60px] sm:h-[50px] md:w-[70px] md:h-[50px] lg:w-[80px] lg:h-[30px] xl:w-[80px] xl:h-[30px] 2xl:w-[80px] 2xl:h-[30px] flex-shrink-0"
                                    style={{
                                        objectFit: 'contain'
                                    }} 
                                />
                                <span 
                                    className="text-white text-center leading-none font-semibold font-noto-sans whitespace-nowrap text-[12px] sm:text-[16px] md:text-[16px] lg:text-[18px] xl:text-[18px] 2xl:text-[18px] opacity-100 flex items-center justify-left"
                                >
                                    Trusted by 3+ million users
                                </span>
                            </div>

                            {/* Bold Heading */}
                            <h2 
                                className="drive-connect-heading  font-oswald text-lg sm:text-3xl md:text-4xl lg:text-[35px] xl:text-[35px] 2xl:text-[35px] leading-[120%] uppercase  mb-4  sm:mb-6 md:mb-8 lg:mb-8 xl:mb-10 2xl:mb-12 ml-0 sm:ml-2 md:mx-auto lg:-ml-5 xl:ml-0 2xl:-ml-52 w-full max-w-full lg:max-w-[680px] xl:max-w-[750px] 2xl:max-w-[726px] md:text-center lg:text-left"
                                style={{
                                    animation: 'insideToOutside 1.2s ease-out 1.7s both',
                                    animationFillMode: 'both',
                                    opacity: 0
                                }}
                            >
                                <span className="drive-connect-animated text-4x ">
                                    DRIVE • CONNECT • UNITE
                                </span>
                            </h2>

                            {/* Main Heading */}
                            <div 
                                className="hero-heading font-oswald text-2xl sm:text-4xl md:text-5xl lg:text-[43px] xl:text-5xl 2xl:text-[75px] leading-[120%] uppercase text-white self-stretch ml-0 sm:ml-2 md:mx-auto lg:ml-0 xl:ml-0 2xl:-ml-52 w-full max-w-full lg:max-w-[680px] xl:max-w-[750px] 2xl:max-w-[726px] md:text-center lg:text-left"
                                style={{
                                    fontStretch: '65%',
                                    animation: 'insideToOutside 1.2s ease-out 1.8s both',
                                    animationFillMode: 'both',
                                    opacity: 0
                                }}
                            >
                                <div className="leading-[120%] text-lg sm:text-3xl md:text-4xl lg:text-[40px] xl:text-[55px] 2xl:text-[55px] md:-mt-1">
                                    <span className="block lg:hidden whitespace-nowrap">
                                        PROFILES THAT DRIVE <span className="text-[#F44C1D]">THE CULTURE</span>
                                    </span>
                                    <div className="hidden lg:flex flex-col gap-4 xl:gap-6 2xl:gap-10 items-start">
                                        <span className="whitespace-nowrap">PROFILES THAT DRIVE <span className="text-[#F44C1D] xl:text-[#F44C1D]">THE</span></span>
                                        <span className="whitespace-nowrap 2xl:mt-4 text-[#F44C1D] xl:text-[#F44C1D]">
                                            CULTURE
                                        </span>
                                    </div>
                                </div>
                            </div>

                            {/* Description */}
                            <p className="hero-description font-noto-sans font-medium text-xs sm:text-sm md:text-lg lg:text-base xl:text-lg 2xl:text-[20px] leading-5 sm:leading-6 md:leading-8 lg:leading-7 xl:leading-8 2xl:leading-[36px] tracking-normal align-middle text-[#8E8E8E] mb-4 sm:mb-6 md:mb-8 lg:mb-8 xl:mb-10 2xl:mb-10 max-w-full sm:max-w-[350px] md:max-w-[450px] lg:max-w-[680px] xl:max-w-[750px] 2xl:max-w-[786px] ml-0 sm:ml-2 md:mx-auto lg:ml-0 xl:ml-0 2xl:-ml-52 mt-4 sm:mt-6 md:mt-8 lg:mt-6 xl:mt-8 2xl:mt-8 md:text-center lg:text-left"
                            style={{
                                animation: 'insideToOutside 1.2s ease-out 2.1s both',
                                animationFillMode: 'both',
                                opacity: 0
                            }}>
                                Where enthusiasts and vendors unite build your profile, share your <span className="hidden lg:inline"><br/></span> passion, and drive the culture forward.
                            </p>

                            {/* Download Buttons */}
                            <div className="hero-buttons flex gap-2 sm:gap-3 md:gap-4 xl:gap-5 flex-wrap ml-0 sm:ml-2 md:mx-auto lg:ml-0 xl:ml-0 2xl:-ml-48 md:justify-center lg:justify-start"
                            style={{
                                animation: 'insideToOutside 1.2s ease-out 2.4s both',
                                animationFillMode: 'both',
                                opacity: 0
                            }}>
                                <a href="https://apps.apple.com/in/app/car-hangout/id6737334627" onClick={() => trackStoreClick('app_store', 'hero')} className="flex items-center w-[140px] sm:w-[165px] md:w-[180px] lg:w-[170px] xl:w-[195px] 2xl:w-[185px] h-[48px] sm:h-[56px] md:h-[60px] lg:h-[58px] xl:h-[66px] 2xl:h-[63px] bg-white rounded-[10px] sm:rounded-xl py-[8px] sm:py-[10px] px-2 sm:px-3 xl:px-4 2xl:px-3 gap-2 sm:gap-3 xl:gap-3.5 2xl:gap-3 opacity-100 no-underline transition-all duration-300 hover:scale-105 hover:shadow-lg lg:ml-0 xl:ml-0 2xl:-ml-6">
                                    <img src="/asset/apple.png" alt="Apple App Store" className="w-[22px] h-[22px] sm:w-[26px] sm:h-[26px] md:w-[28px] md:h-[28px] lg:w-[28px] lg:h-[28px] xl:w-[32px] xl:h-[32px] 2xl:w-[30px] 2xl:h-[30px] flex-shrink-0" />
                                    <div className="flex flex-col gap-0.5 sm:gap-1">
                                        <div className="text-black/70 text-[10px] sm:text-[13px] md:text-[14px] lg:text-[14px] xl:text-[16px] 2xl:text-[15px] leading-[100%] font-noto-sans font-semibold tracking-[0.01em] align-middle whitespace-nowrap">
                                            Download on the
                                        </div>
                                        <div className="text-black text-[12px] sm:text-[15px] md:text-[16px] lg:text-[16px] xl:text-[18px] 2xl:text-[17px] leading-[100%] font-noto-sans font-bold tracking-[0.01em] align-middle whitespace-nowrap">
                                            App Store
                                        </div>
                                    </div>
                                </a>
                                
                                <a href="https://play.google.com/store/apps/details?id=com.car.hangout" onClick={() => trackStoreClick('play_store', 'hero')} className="flex items-center w-[140px] sm:w-[165px] md:w-[180px] lg:w-[170px] xl:w-[195px] 2xl:w-[185px] h-[48px] sm:h-[56px] md:h-[60px] lg:h-[58px] xl:h-[66px] 2xl:h-[63px] bg-white rounded-[10px] sm:rounded-xl py-[8px] sm:py-[10px] px-2 sm:px-3 xl:px-4 2xl:px-3 gap-2 sm:gap-3 xl:gap-3.5 2xl:gap-3 opacity-100 no-underline transition-all duration-300 hover:scale-105 hover:shadow-lg">
                                    <img src="/asset/google-play.png" alt="Google Play App Store" className="w-[24px] h-[24px] sm:w-[28px] sm:h-[28px] md:w-[29px] md:h-[29px] lg:w-[29px] lg:h-[29px] xl:w-[33px] xl:h-[33px] 2xl:w-[31px] 2xl:h-[31px] flex-shrink-0" />
                                    <div className="flex flex-col gap-0.5 sm:gap-1">
                                        <div className="font-noto-sans font-semibold text-[10px] sm:text-[13px] md:text-[14px] lg:text-[14px] xl:text-[16px] 2xl:text-[15px] leading-[100%] tracking-[0.01em] align-middle whitespace-nowrap" style={{ color: '#000000B2' }}>
                                            Get it on
                                        </div>
                                        <div className="font-noto-sans font-bold text-[12px] sm:text-[15px] md:text-[16px] lg:text-[16px] xl:text-[18px] 2xl:text-[17px] leading-[100%] tracking-[0.01em] align-middle whitespace-nowrap" style={{ color: '#000000' }}>
                                            Google Play
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>

                        {/* Right Content - Car Images */}
                        <div className="lg:w-1/2 w-full flex justify-center items-center relative min-h-[350px] xs:min-h-[400px] sm:min-h-[480px] md:min-h-[526px] lg:min-h-[560px] xl:min-h-[90px] xl:mb-[500px] 2xl:min-h-[320px]">
                            {/* Car Image 1 - Left Side */}
                            <div className="car-image-1 absolute z-20 md:z-30 lg:z-20 transition-transform duration-300 left-4 sm:left-[10px] md:left-[100px] lg:left-[-12px] xl:left-[-40px] 2xl:left-[10px] top-10 sm:top-12 md:top-14 lg:top-20 xl:top-14 2xl:top-18 animate-slide-in-left"
                            style={{
                                animationDelay: '024s',
                                animationFillMode: 'both',
                                animation: 'slideInFromLeft 1.5s ease-out 0.2s both'
                            }}>
                                <img
                                    src="/asset/car1.png"
                                    alt="Car Hangout Car Image "
                                    className="h-auto rounded-2xl shadow-2xl w-[200px] sm:w-[240px] md:w-[280px] mdx:w-[320px] lg:w-[280px] xl:w-[340px] 2xl:w-[430px]"
                                />
                            </div>

                            {/* Car Image 3 - Right Side */}
                                 
                            <div className="car-image-2 img-2 absolute z-10 md:z-20 lg:z-10 top-[60px] sm:top-[80px] md:top-[100px] lg:top-[120px] xl:top-[180px]  2xl:top-[140px] right-[80px] mdx:right-[60px] sm:right-[30px] md:right-[10px] lg:right-[-6px] xl:right-[78px] 2xl:right-[-90px] sm:p-1 mt-8 sm:mt-6 md:mt-6 lg:mt-10 xl:mt-[-20px]  xl:2xl:mt-[20px] opacity-90 md:opacity-100 animate-slide-from-behind "
                            style={{
                                animationDelay: '1.9s',
                                animationFillMode: 'both'
                            }}>
                                <div className="relative transition-transform duration-300">
                                    <img
                                        src="/asset/car.png"
                                        alt="Car Hangout Car Image"
                                        className="h-auto rounded-2xl shadow-2xl w-[200px] sm:w-[240px] md:w-[280px]  lg:w-[260px] xl:w-[330px] 2xl:w-[410px] mdx:w-[300px]"
                                    />
                                    {/* Bottom Blur Effect */}
                                    <div className="absolute bottom-[20px] left-0 right-0 h-[100px] bg-gradient-to-t from-[#0F0F10] to-transparent rounded-b-2xl pointer-events-none"></div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <img src="/asset/rec.png" alt="Hero Section Bottom Banner" className="hero-boottom-banneer" />
            </section>
                                        


                                        
            <Events />
            
            <main className="relative z-10">
                {children}
            </main>
        </div>
        </>
    );
};

export default Hero;
